/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import GeneralFilter from "../../../Shared/Filter/GeneralFilter";
import { resetEventFilters } from "../../../../store/filters/events/EventFilterReducer";
import { useActivityLogFilter } from "./hooks";

export const ActivityLogFilter = () => {
  const { dispatch, eventFilters, formControlSx, searchTooltip } = useActivityLogFilter();

  return (
    <>
      <GeneralFilter dispatch={dispatch} filters={eventFilters} formControlSx={formControlSx} resetFilters={resetEventFilters} searchTooltip={searchTooltip} />
    </>
  );
};

export default ActivityLogFilter;
